// components/inventory/InventoryTable.jsx
import React from 'react';
import { Trash2, Plus } from 'lucide-react';

const InventoryTable = ({ 
  items = [], 
  onDeleteItem, 
  onAddItem,
  showAddButton = true 
}) => {
  return (
    <div className="bg-white rounded-lg border">
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b">
        <h3 className="font-semibold">Inventory Items</h3>
        {showAddButton && onAddItem && (
          <button
            onClick={onAddItem}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
          >
            <Plus size={16} />
            Add Item
          </button>
        )}
      </div>

      {/* Table Content */}
      {items.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">PRODUCT NO.</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">PRODUCT NAME</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">DESCRIPTION</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">WEIGHT (KG)</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">TOTAL QTY</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">AVAILABLE QTY</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">ACTIONS</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {items.map((item) => (
                <TableRow 
                  key={item.id} 
                  item={item} 
                  onDelete={() => onDeleteItem(item.id)} 
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState />
      )}
    </div>
  );
};

const TableRow = ({ item, onDelete }) => {
  const isLowStock = item.availableQuantity < 10;
  
  return (
    <tr className="hover:bg-gray-50">
      <td className="px-4 py-3 text-sm">{item.productNo}</td>
      <td className="px-4 py-3 text-sm font-medium">{item.productName}</td>
      <td className="px-4 py-3 text-sm text-gray-600">{item.description || '-'}</td>
      <td className="px-4 py-3 text-sm">{item.weight || '-'}</td>
      <td className="px-4 py-3 text-sm">{item.totalQuantity}</td>
      <td className="px-4 py-3 text-sm">
        <span className={`font-medium ${isLowStock ? 'text-red-600' : 'text-green-600'}`}>
          {item.availableQuantity}
        </span>
      </td>
      <td className="px-4 py-3">
        <button
          onClick={onDelete}
          className="text-red-600 hover:text-red-800 p-1"
          title="Delete item"
        >
          <Trash2 size={16} />
        </button>
      </td>
    </tr>
  );
};

const EmptyState = () => (
  <div className="p-8 text-center text-gray-500">
    <p>No items in this inventory</p>
    <p className="text-sm mt-1">Add some items to get started</p>
  </div>
);

export default InventoryTable;